<template>
  <div>
    <div class="item-container" :class="{ 'error-border': item.invalid_file }">
      <span class="close" @click.prevent="removeFile" v-if="!sart_progressing"
        >X</span
      >
      <span
        v-if="sart_progressing && item.progressing > 0"
        class="percentage"
        :class="{
          'loading-send': sart_progressing
        }"
        >{{ item.progressing }}</span
      >
      <div
        class="loding-spin"
        :class="{
          'loading-send': sart_progressing
        }"
        v-if="sart_progressing"
      ></div>
      <img :src="image" alt v-if="image" />
      <a href="#" v-else>
        <a-icon type="file" :style="{ fontSize: '16px', color: '#08c' }" />
      </a>
    </div>
    <a
      href="#"
      style="font-size: 9px;"
      v-if="item.uploaded"
      @click.prevent="onDownload"
      >{{ $t('dealerProfile.download') }}</a
    >
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'

export default {
  name: 'viewFile',
  props: {
    item: {
      type: Object
    },
    fileIndex: {
      type: Number
    }
  },
  data() {
    return {
      image: '',
      sart_progressing: false
    }
  },
  created() {
    this.readAsUrl()
  },
  methods: {
    ...mapActions('administrator/dealerProfile', ['download']),
    readAsUrl() {
      if (['image/png', 'image/jpeg'].includes(this.item.type)) {
        if (this.item.uploaded && this.item.size == 0) {
          this.image = this.item.storage_path
          return
        }
        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
        }
        reader.readAsDataURL(this.item.file)
      }
    },
    removeFile() {
      this.$emit('remove', { index: this.fileIndex, record: this.item })
    },
    onDownload() {
      this.sart_progressing = true
      this.download({
        filePath: this.item.storage_path
      })
        .then(response => {
          let filename = response.headers['content-disposition']
            .substring(
              response.headers['content-disposition'].indexOf('filename')
            )
            .replace('filename=', '')

          FileDownload(
            response.data,
            filename.substring(1, filename.length - 1)
          )
        })
        .catch(errorData => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(errorData))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.sart_progressing = false
        })
    }
  },
  watch: {
    item: {
      handler() {
        this.readAsUrl()
      },
      deep: true
    },
    'item.progressing': function($value) {
      if ($value < 100 && $value != 0) {
        this.sart_progressing = true
      } else {
        this.sart_progressing = false
      }
    }
  }
}
</script>

<style scoped>
img {
  height: 130px;
  border-radius: 8px;
  padding: 3px;
  object-fit: cover;
  object-position: center;
  background: #fff7f7;
}
.item-container {
  position: relative;
  border: 1px solid #e8e5e5;
  margin-right: 7px;
  border-radius: 8px;
  width: 100%;
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-container:hover .close {
  visibility: visible;
}
.close {
  visibility: hidden;
  position: absolute;
  background: red;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  top: 50px;
  left: 33%;
  height: 26px;
  width: 26px;
  border-radius: 16px;
  opacity: 43%;
}
.percentage {
  visibility: hidden;
  position: absolute;
  background: red;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  top: 50px;
  left: 40%;
  height: 30px;
  width: 30px;
  border-radius: 16px;
  opacity: 80%;
}
.loding-spin {
  visibility: hidden;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 2px solid rgba(255, 251, 0, 0.2);
  border-left-color: rgb(255, 255, 255);
  background: transparent;
  animation: rotate-s-loader 1s linear infinite;
  top: 48px;
  left: 39%;
  position: absolute;
}

@keyframes rotate-s-loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.error-border {
  border: 1px solid red !important;
}
.loading-send {
  visibility: visible !important;
}
</style>
